import { GalleryDto } from '@nusign/picflow-backend-types';
import { textCollator } from './text-collator';

export const sortGalleries = (galleries: GalleryDto[], sorting: string) => {
  const inverted = sorting.startsWith('-');
  const key = sorting.replace('-', '');

  let sortedGalleries = galleries.slice().sort((a, b) => a.id.localeCompare(b.id));

  if (key === 'title') {
    sortedGalleries = [
      ...sortedGalleries.filter(g => g.title).sort((a, b) => textCollator.compare(a.title, b.title)),
      ...sortedGalleries.filter(g => !g.title),
    ];
  } else {
    sortedGalleries.sort((a, b) => a[key] - b[key]);
  }

  if (inverted) sortedGalleries.reverse();
  return sortedGalleries;
};
